module.exports = __webpack_public_path__ + "static/app-architecture-11d77af5e8a557acd15d5e1d5605e221.png";